import { render, staticRenderFns } from "./Buchungssaetze.vue?vue&type=template&id=a74112b0&"
import script from "./Buchungssaetze.vue?vue&type=script&lang=ts&"
export * from "./Buchungssaetze.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports